import { Handle, Position } from 'reactflow';
import { NodeProps } from 'reactflow';
import { SubFlow } from '../../configLookup/components/Props';
import styles from '../configInfo.module.css';
import { VegaCard, VegaFlex, VegaFont } from '@globalpayments/vega-react';

function SubFlowNode({ data }: NodeProps<SubFlow>) {
  return (
    <div>
      <Handle type="target" position={Position.Top} isConnectable={false} />
      <div>
        <VegaCard className={styles.subFlowNode} padding="size-16" variant="border">
          <VegaFlex direction="col" gap="size-8">
            <VegaFont as="h3" color="text-primary" variant="font-h5">{data.name}</VegaFont>
            <VegaFont as="p" color="text-primary" variant="font-p2-short"><strong>Type:</strong> {data.subFlowType}</VegaFont>
            <VegaFont as="p" color="text-primary" variant="font-p2-short"><strong>Description:</strong></VegaFont>
            <VegaFont as="p" className={styles.breakWord} color="text-primary" variant="font-p2-short">{data.subFlowDescription || 'N/A'}</VegaFont>
            <VegaFont as="p" color="text-primary" variant="font-p2-short"><strong>Ordinal:</strong> {data.ordinal}</VegaFont>
          </VegaFlex>
        </VegaCard>
        <Handle type="source" position={Position.Bottom} isConnectable={false} />
      </div>
    </div>
  );
}

export default SubFlowNode;
